import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig, testAppConfig } from './app/app.config';
import { registerLocaleData } from '@angular/common';
import { RsSentry } from '@rs-shared-lib/utils/rs-senty-init';
import { environment } from '@environments/environment';
import localeFr from '@angular/common/locales/fr';
import localeNl from '@angular/common/locales/nl';
import localeEn from '@angular/common/locales/en-GB';
import localeDe from '@angular/common/locales/de';
import * as Sentry from '@sentry/angular';
import { enableProdMode } from '@angular/core';

registerLocaleData(localeFr);
registerLocaleData(localeNl);
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe);

new RsSentry({
  dsn: 'https://1afaf822d6ab4f0c904d8e7a0b3614a8@o268277.ingest.us.sentry.io/4509349763350528',
  enabled: environment.enableSentryMonitoring,
  environment: environment.environment,
  sentryReleaseName: environment.sentryReleaseName,
}).sentryInit();

Sentry.getCurrentScope().setTag('app.name', 'REI');
Sentry.getCurrentScope().setTag('app.environment', environment.environment);

if (environment.production) {
  enableProdMode();
}

const config = environment.environment === 'mock' ? testAppConfig : appConfig;

bootstrapApplication(AppComponent, config).catch((err) => console.error(err));
